import React, { useEffect } from 'react';

import ISimpleField from './ISimpleField.interface';
import SimpleButton from '../SimpleButton';
import Validator from './validator';
import makeField from './makeField';
import useForm from './useForm';

export interface ISimpleForm {
    /** Heading displayed at the top of the form */
    heading?: string;

    /** Callback fired when form is submitted and passes validation */
    onSubmit: Function;

    /** Flag to attempt to submit on data change (useful for toggles) */
    submitOnChange?: boolean;

    /** Identifier used for the form's 'id' attribute */
    id: string;

    /** Label to appear on the button that triggers the form submission */
    buttonLabel?: string;

    /** Map of default values that will be passed into the hook, and set as the value for the particular field dictated by the key*/
    defaultValues?:
        | {
              [key: string]: any;
          }
        | undefined;
    /** Hides the button */

    /** manually trigger submit */
    triggerSubmit?: boolean;
    hideButton?: boolean;
    /** Array of field objects */
    fields: [ISimpleField];
}
const SimpleForm = ({
    buttonLabel,
    defaultValues,
    fields,
    heading,
    hideButton,
    id,
    onSubmit,
    submitOnChange,
    triggerSubmit,
}: ISimpleForm) => {
    const { ...hook } = useForm(onSubmit, Validator(fields), submitOnChange);

    useEffect(() => {
        //If defaultValues are present, we pass these into our hook
        if (defaultValues) Object.keys(defaultValues).map(key => hook.setValues({ [key]: defaultValues[key] }));
        // eslint-disable-next-line
    }, [defaultValues]);

    return (
        <React.Fragment>
            {heading && <h2>{heading}</h2>}
            <form data-cy="SimpleForm" id={id} onSubmit={hook.handleSubmit}>
                {fields &&
                    fields.map((field, idx) => {
                        return makeField(field, idx, hook);
                    })}
                {!hideButton && <SimpleButton action={hook.handleSubmit} label={buttonLabel} textColor="white" />}
            </form>
        </React.Fragment>
    );
};

export default SimpleForm;
